import React, { useEffect } from "react"
import { Col, Container, Row } from "reactstrap"

// Gatsby specific imports
import { graphql, Link, useStaticQuery } from "gatsby"
import {
  // GatsbyImage,
  getImage,
} from "gatsby-plugin-image"
import BackgroundImage from "gatsby-background-image"
import { convertToBgImage } from "gbimage-bridge"

// component
import WorkProcess from "./WorkProcess"

// icons
import { UilArrowRight } from "@iconscout/react-unicons"

const AboutPage = () => {
  useEffect(() => {
    document.body.classList = ""
    document.getElementById("top-menu").classList.add("nav-light")
    // document.getElementById("buyButton").className = "btn btn-light"
    window.addEventListener("scroll", scrollNavigation, true)

    // clean up function
    return () => {
      // Make sure to remove the DOM listener when the component is unmounted.
      window.removeEventListener("scroll", scrollNavigation, true)
    }
  }, [])

  const scrollNavigation = () => {
    var doc = document.documentElement
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
    if (top > 80) {
      document.getElementById("topnav").classList.add("nav-sticky")
      // document.getElementById("buyButton").className = "btn btn-primary"
    } else {
      document.getElementById("topnav").classList.remove("nav-sticky")
      // document.getElementById("buyButton").className = "btn btn-light"
    }
  }

  const data = useStaticQuery(graphql`
    {
      markdownRemark(frontmatter: { contentKey: { eq: "aboutPage" } }) {
        frontmatter {
          hero_section_of_about_page {
            heading
            sub_heading
            background_image {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          who_am_i {
            title
            cta_btn
            featured_image {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        html
      }
    }
  `)

  const {
    //  heading,
    //  sub_heading,
    background_image,
  } = data.markdownRemark.frontmatter.hero_section_of_about_page

  // Background Image Stuff
  const image = getImage(background_image)
  const bgImage = convertToBgImage(image)

  // Who am I Section
  const {
    title,
    cta_btn,
    //  featured_image
  } = data.markdownRemark.frontmatter.who_am_i

  const { html } = data.markdownRemark

  return (
    <>
      <BackgroundImage
        className="bg-half d-table w-100"
        Tag="section"
        // Spread bgImage into BackgroundImage:
        {...bgImage}
        preserveStackingContext
      >
        <div className="bg-overlay"></div>
        <Container>
          <Row className="justify-content-center">
            <Col lg={12} className="text-center">
              <div className="page-next-level title-heading">
                {/* To Do: writing below is no longer wanted, so it should be detached from the backend later */}
                {/* <h1 className="text-white title-dark"> {heading} </h1>
                <p className="text-white-50 para-desc mb-0 mx-auto">
                  {sub_heading}
                </p> */}
                <div className="page-next">
                  <nav aria-label="breadcrumb" className="d-inline-block">
                    <ul className="breadcrumb bg-white rounded shadow mb-0">
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        About
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </BackgroundImage>
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <section className="section">
        <Container>
          <Row className="align-items-center" id="counter">
            {/* <Col md={6}> */}
            {/* <img
                src={aboutImage}
                className="img-fluid"
                alt="Muhammad Ilyas"
              /> */}
            {/* <GatsbyImage
              image={getImage(featured_image)}
              className="img-fluid"
              alt="Muhammad Ilyas"
            /> */}
            {/* </Col> */}

            <Col md={12} className="mt-4 pt-2 mt-sm-0 pt-sm-0 ">
              <div className="ms-lg-4">
                <div className="section-title">
                  <h4 className="title mb-4 text-center">{title}</h4>

                  <section
                    className="mt-3"
                    dangerouslySetInnerHTML={{
                      __html: html,
                    }}
                  />

                  <Link to="/contact" className="btn btn-primary mt-3 ">
                    {cta_btn} <UilArrowRight />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="section bg-light">
        <WorkProcess />
      </section>
    </>
  )
}

export default AboutPage
